<template>
    <main class="lg:mb-[600px] relative z-10 bg-backgroundBody dark:bg-dark">
      <!--=====================================
           Page Header Section
      =====================================-->
      <section class="pt-28 sm:pb-28 max-md:pb-16 md:py-[155px] lg:py-[177px] relative z-50 overflow-hidden">
        <div id="hero-gradient-wrapper" class="absolute w-full h-full top-0 left-0 -z-10 blur-[35px] md:blur-[60px] scale-75">
          <!-- Gradient Background Image: Positioned centrally with responsive sizing -->
          <img src="@/assets/images/hero-gradient-background.png" alt="hero-gradient-background" id="hero-gradient" class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2" />
        </div>
    
        <!-- Content Container -->
        <div class="container">
          <!-- Centered Content with Animation -->
          <div class="text-center reveal-me">
            <!-- Badge Component -->
            <div class="rv-badge">
              <span class="rv-badge-text">Project case study</span>
            </div>
    
            <!-- Title and Description -->
            <h1 class="mt-3.5 sm:mt-5 lg:mt-9 mb-3 sm:mb-4 lg:mb-7">
                Eoncycle: Shopify Built for <span class="font-instrument italic">Motion</span>
            </h1>
            <p>
                Introducing Eoncycle – a high-performance Shopify eBike store crafted for clean design, quick browsing, and strong conversions. With striking visuals, streamlined UX, and optimized speed, Eoncycle powers online sales in the growing electric bike market.
            </p>
          </div>
        </div>
      </section>
    
      <!--=====================================
           Documentation Section
      =====================================-->
      <section class="pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px]">
        <div class="max-w-[1440px] mx-auto px-7 md:px-20">
          <div class="flex flex-col gap-x-8 gap-y-12 lg:flex-row">
            <!-- Sticky Table of Contents Sidebar -->
            <aside class="min-w-[275px] lg:mx-auto flex-1">
              <div class="sticky top-40">
                <div class="reveal-me">
                  <h3 class="max-md:text-[40px] md:text-[32px]">Table of contents</h3>
                  <ul class="mt-7 md:mt-10 [&>*:not(:last-child)]:mb-3 md:[&>*:not(:last-child)]:mb-5">
                    <li>
                      <a href="#project-overview" class="text-xl normal-case font-normal leading-7 tracking-normal text-[#000000b3] dark:text-dark-100 hover:font-medium hover:text-secondary dark:hover:text-backgroundBody transition-all lenis-scroll-to">
                        Learn about the project - Project Overview
                      </a>
                    </li>
                    <li>
                      <a href="#designing" class="text-xl normal-case font-normal leading-7 tracking-normal text-[#000000b3] dark:text-dark-100 hover:font-medium hover:text-secondary dark:hover:text-backgroundBody transition-all lenis-scroll-to">
                        Designing the User Experience
                      </a>
                    </li>
                    <li>
                      <a href="#architecture" class="text-xl normal-case font-normal leading-7 tracking-normal text-[#000000b3] dark:text-dark-100 hover:font-medium hover:text-secondary dark:hover:text-backgroundBody transition-all lenis-scroll-to">
                        Building the information architecture
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </aside>
    
            <!-- Main Content Area -->
            <article class="project-details-body">
              <figure class="reveal-me">
                <img src="@/assets/images/services/eoncycle-1.png" alt="Services Big Img" />
              </figure>
              <div class="reveal-me">
                <h3 id="project-overview">
                  Learn about the project - Project Overview
                </h3>
                <p>
                    Eoncycle is a modern Shopify storefront created to drive electric bike sales with confidence. Built for scale and speed, it showcases sleek eBikes using bold imagery, mobile-optimized layouts, and a frictionless checkout experience.
                    <br><br>
                    From first impression to final purchase, Eoncycle is engineered to convert.

                </p>
              </div>
              <div class="reveal-me">
                <h3 id="designing">Designing the User Experience</h3>
                <p>
                    The UX behind Eoncycle focuses on clarity, motion, and trust. Every detail—scroll behavior, nav structure, product display—was designed to keep shoppers engaged and moving forward.
                    <br><br>
                    We used full-bleed visuals, sticky CTAs, and clean product pages to remove hesitation and create a premium, responsive flow from homepage to checkout.
                </p>
                <img src="@/assets/images/services/eoncycle-process.png" alt="Project details Button Img" />
              </div>
              <div class="reveal-me">
                <h3 id="architecture">Building the information architecture</h3>
                <p>
                    Eoncycle’s backend architecture uses advanced Shopify features like dynamic collections, metafields, and a modular structure. This makes the site easy to update, expand, and scale as the brand grows.
                    <br><br>
                    With clearly organized categories and intuitive product discovery, customers can find what they need fast—on desktop or mobile.
                </p>
                <img id="final-design" src="@/assets/images/services/eoncycle-2.png" alt="Business Card" />
              </div>
            </article>
          </div>
        </div>
      </section>
    
      <!--=====================================
           CTA Section
      =====================================-->
      <section
      class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-[70px] lg:pb-[140px] relative"
    >
      <div class="container">
        <!-- CTA Heading -->
        <h2
          class="text-center xl:text-[96px] font-normal xl:leading-[1.1] xl:tracking-[-2.88px]"
        >
          Got Questions?
          <span class="font-instrument sm:mt-10 italic block max-md:inline-block"
            >We’ve Got Answers</span
          >
        </h2>
    
        <ul
        class="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 list-none"
      >
          <!-- Primary CTA Button -->
          <li
            class="block md:inline-block w-[90%] mx-auto md:ml-auto md:mr-0 md:w-auto"
          >
          
          </li>
          <!-- Secondary CTA Button -->
          <li
            class="block md:inline-block w-[90%] mx-auto md:mr-auto md:ml-0 md:w-auto"
          >
            <router-link
              to="/contact"
              class="rv-button rv-button-primary block md:inline-block"
            >
              <div class="rv-button-top contact-btn-lg">
                <span>Let's Connect</span>
              </div>
              <div class="rv-button-bottom contact-btn-lg">
                <span>Let's Connect</span>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </section>
    </main>
    <!--=====================================
         Footer Section
    ======================================-->
    <FooterComponent/>
    
    
    </template>
    <script>
    import FooterComponent from '@/components/FooterComponent.vue'
    export default {
      name: 'EoncyclePage',
      components: {
        FooterComponent,
      }
    }
    </script>